import { Alert, Snackbar } from '@mui/material';
import { useAtom } from 'jotai';
import { snackbarStyles } from './SnackbarProps';
import { hideSnackbarAtom, snackbarAtom } from '../../store/snackbarStore';
import XIcon from '../../assets/icons/XIcon';
import CheckmarkRoundIcon from '../../assets/icons/CheckmarkRoundIcon';

function SnackbarInfo() {
  const [snackbarState] = useAtom(snackbarAtom);
  const [, hideSnackbar] = useAtom(hideSnackbarAtom);

  const handleClose = () => {
    hideSnackbar();
  };

  const customIcons = ({
    onSuccessClick,
    onErrorIconClick,
  }: {
    onSuccessClick: () => unknown;
    onErrorIconClick: () => unknown;
  }) => ({
    success: <CheckmarkRoundIcon onClick={onSuccessClick} />,
    error: <XIcon onClick={onErrorIconClick} />,
  });

  return (
    <Snackbar
      open={snackbarState.open}
      autoHideDuration={6000}
      onClose={handleClose}
      data-testid="snackbar"
    >
      <Alert
        onClose={handleClose}
        severity={snackbarState.type}
        variant="filled"
        sx={snackbarStyles}
        iconMapping={customIcons({
          onErrorIconClick: handleClose,
          onSuccessClick: handleClose,
        })}
      >
        {snackbarState.text}
      </Alert>
    </Snackbar>
  );
}

export default SnackbarInfo;
